// Styles
import './LoadingSpinner.css'

const LoadingSpinner = () => {
  return (
    <div className='LoadingSpinner-wrapper'>
      <div className='LoadingSpinner' />
      <p className='LoadingSpinner-text'>Carregando...</p>
    </div>
  )
}

export default LoadingSpinner